import { Component, OnInit } from "@angular/core";
import { Configurations } from "../../core/configurations";
import { UltimaVersioneApplicativoClientService } from "../../services/ultima-versione-applicativo-client.service";


@Component({
    selector: "public-richiesta-layout-component",
    moduleId: module.id,
    templateUrl: "public-richiesta-layout.component.html",
    styleUrls: ['./public-layout.component.css']

})
export class PublicRichiestaLayoutComponent implements OnInit {

    pathImmagini:string=Configurations.baseUrl+"assets/imgs";
    codVersioneImg:string;
    isTest:boolean=Configurations.published?false:true;
    constructor(private _ultimaVersioneClientTipo:UltimaVersioneApplicativoClientService) {
      
    }
    ngOnInit(): void {
        this._ultimaVersioneClientTipo.getUltimaVersioneApplicativo()
        .subscribe(data => {
          Configurations.currentVersionCod=data.codice;
          let v=localStorage.getItem('clientVersion');
          if(v===null||v===undefined||v!==data.codice) {
            localStorage.setItem('clientVersion',data.codice);
            alert("Sono state pubblicate delle modifiche nel portale, per poterle caricare verrà indirizzato alla homepage.");
            window.location.href=Configurations.baseUrl;
            
          }
        });
    }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/layout/public-richiesta-layout.component.ts